(function () {

  var idme =
    '<div class="idme">' +
    '<div class="idme-shopify">' +
    "<p class='idme-btn-affinity'>Select communities receive an exclusive discount with ID.me</p>" +
    '<a class="idme-btn-unify" href="https://discountify.id.me/oauth/checkpoint/forcis-apparel">' +
    '<img src="https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg" alt="ID.me" style="height:38px"/>' +
    "</a>" +
    "</div>" +
    "</div>";

  function tryInsert() {
    var checkout = document.getElementsByName("checkout")[0];
    if (!checkout) return false;
    if (
      checkout.nextElementSibling &&
      checkout.nextElementSibling.classList.contains("idme")
    ) {
      return true;
    }
    checkout.insertAdjacentHTML("afterend", idme);
    return true;
  }

  if (tryInsert()) return;

  var observer = new MutationObserver(function () {
    if (tryInsert()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  setTimeout(function () {
    observer.disconnect();
  }, 60000);
})();